import PropTypes from "prop-types";
import { RadioSegments } from "@/components/ui/radio-segments";
import FieldError from "./FieldError";
import SettingsSection from "./SettingsSection";
import { fieldId, VERTICAL_PULLS } from "./settingsForm";

/** Which vertical pull is the main lift (D17: separate histories). */
function VerticalPullSection({ value, onChange, error }) {
  return (
    <SettingsSection
      id="training-settings-vertical-pull"
      title="Vertical pull"
      description={
        <p>
          The one plans use as the main lift; the other stays its swap. They keep separate
          histories, so switching starts the other from its own log (or “Find your weight”).
        </p>
      }
    >
      <div className="flex flex-col gap-1.5">
        <RadioSegments
          legend="Main vertical pull"
          options={VERTICAL_PULLS}
          value={value}
          onChange={onChange}
          stacked
          className="max-w-md"
        />
        <FieldError id={`${fieldId("vertical_pull")}-error`}>{error}</FieldError>
      </div>
    </SettingsSection>
  );
}

VerticalPullSection.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default VerticalPullSection;
